export default __webpack_public_path__ + "static/media/es.d6b5c97b.svg";